import type { RiskRecognitionHighlight } from '@cobliteam/api-lib/src/dashboard/riskRecognitions/Types';
import type { FeedItem } from '@knocklabs/client';
import type { NotificationType } from '../../core/NotificationType';
import useRiskCardController from './hooks/useRiskCardController';
import useRiskToastController from './hooks/useRiskToastController';
import { getHighlightFromFeedItem, RISK_RECOGNITION_WORKFLOW_KEYS, type RiskRecognitionFeedItem } from './parse';
import RiskRecognitionDrawer from './RiskDrawer';

/**
 * Registro do tipo `risk-recognition` — o primeiro tipo de notificação. Liga o contrato genérico (parse,
 * surfaces, controllers, drawer) à implementação concreta do risco. Foi desenhado contra um segundo tipo
 * (gêmeo: mesmo feed, workflow keys próprias, 4 surfaces, ação que abre drawer, dismiss local).
 */
export const riskRecognitionType: NotificationType<RiskRecognitionHighlight> = {
  key: 'risk-recognition',
  workflowKeys: RISK_RECOGNITION_WORKFLOW_KEYS,
  parse: (item: FeedItem) => getHighlightFromFeedItem(item as unknown as RiskRecognitionFeedItem),
  surfaces: { feed: true, card: true, toast: true, drawer: true },
  useCardController: useRiskCardController,
  useToastController: useRiskToastController,
  Drawer: RiskRecognitionDrawer,
};
